<template>
  <div class="clearfix font-size-14 font-weight-400 flex align-center">
    <div class="back flex align-center" @click="backUrl" v-if="levelList.length > 1">
      <img src="@/images/nav/backUrl.png" alt srcset />返回
    </div>
    <div class="navLine" v-if="levelList.length > 1"></div>
    <el-breadcrumb class="breadcrumb-container" separator="/">
      <template v-for="(item,index) in levelList">
        <el-breadcrumb-item
          :key="item.path"
          :to="index != levelList.length-1?item.path:''"
          :class="index == levelList.length -1 && levelList.length > 1 ? 'levelListSelect':''"
        >{{item.meta.title}}</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "crumbs",
  data() {
    return {
      levelList: [],
    };
  },
  watch: {
    $route() {
      this.getBreadcrumb();
    },
  },
  created() {
    this.getBreadcrumb();
  },
  methods: {
    getBreadcrumb() {
      let matched = this.$route.matched.filter((item) => item.meta.title),
        levelList = [];
      const first = matched[0];
      matched.forEach((item) => {
        if (!item.meta.hiddenCrumbs) {
          levelList.push(item);
        }
      });
      this.levelList = levelList;
    },
    backUrl() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.clearfix {
  background: #f4f6f9;
}
.navLine {
  width: 0.01rem;
  height: 0.12rem;
  background: #dcdfe6;
  margin: 0 0.12rem;
}
.back {
  font-family: PingFangSC-Regular, PingFang SC;
  color: #242e42;
  line-height: 1;
  cursor: pointer;
  img {
    width: 0.08rem;
    height: 0.1rem;
    margin-right: 0.06rem;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/crumbs.vue